<div class="license-tracker">
  <!-- <div class="license-tracker-title"> -->
  <!-- <h1>License Tracker</h1> -->
  <!-- </div> -->
  <div class="chart-section-container mat-elevation-z1">
    <div class="chart-container">
      <h3 class="mat-title">
        {{ companyName }} NFC Credential Solution Breakdown
      </h3>
      <canvas id="licenseTrackerChart" width="100%" height="200"></canvas>
      <br />
      <h5>
        *Hover over each section of the graph to view License breakdown totals*
      </h5>
    </div>
  </div>
</div>
